function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4,4 L20,4 C20.5522847,4 21,4.44771525 21,5 C21,5.55228475 20.5522847,6 20,6 L4,6 C3.44771525,6 3,5.55228475 3,5 C3,4.44771525 3.44771525,4 4,4 Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.7665414,0.445309849 C11.3126249,-0.106937945 12.18148,-0.146139398 12.7733286,0.331072971 L12.8937984,0.439339792 L16.8535534,4.39909479 C17.0488155,4.59435693 17.0488155,4.91093942 16.8535534,5.10620157 C16.679987,5.27976792 16.4105626,5.29905307 16.2156945,5.16405702 L16.1464466,5.10620157 L12.1847012,1.1444673 C11.9883462,0.950304732 11.6717689,0.952081929 11.4776062,1.14843636 L11.1546207,1.46737423 C10.6884999,1.91824246 10.0803973,2.47168465 9.3292523,3.12893652 C9.12143399,3.31077755 8.80555268,3.2897188 8.62371165,3.08190048 C8.44187063,2.87408216 8.46292938,2.55820085 8.6707477,2.37635983 L9.1973858,1.91164303 C9.86383184,1.31808662 10.3872371,0.828897077 10.7665414,0.445309849 Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4,22 L20,22 C20.5522847,22 21,22.4477153 21,23 C21,23.5522847 20.5522847,24 20,24 L4,24 C3.44771525,24 3,23.5522847 3,23 C3,22.4477153 3.44771525,22 4,22 Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5,4.5 C5.24545989,4.5 5.44960837,4.67687516 5.49194433,4.91012437 L5.5,5 L5.5,22.5 L18.5,22.5 L18.5,7 C18.5,6.75454011 18.6768752,6.55039163 18.9101244,6.50805567 L19,6.5 C19.2454599,6.5 19.4496084,6.67687516 19.4919443,6.91012437 L19.5,7 L19.5,23.5 L4.5,23.5 L4.5,5 C4.5,4.72385763 4.72385763,4.5 5,4.5 Z"
});

var SvgTextilposter = function SvgTextilposter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTextilposter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/textilposter.3f0cd48d.svg";
export { ForwardRef as ReactComponent };